import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Loading } from "../components/Loader";
import { Select } from "../components/Select";
import {
  fetchStockAdjustments,
  selectStockAdjustments,
  selectStockAdjustmentsError,
  selectStockAdjustmentsStatus,
} from "../features/stockAdjustments/stockAdjustmentsSlice";
import { STATUS_LABELS, REASON_LABELS, statusColor, formatDateTime } from "./stockAdjustmentShared";
import "./StockAdjustmentPages.css";

const STATUS_OPTIONS = [
  { value: "", label: "Все статусы" },
  { value: "draft", label: STATUS_LABELS.draft },
  { value: "posted", label: STATUS_LABELS.posted },
  { value: "cancelled", label: STATUS_LABELS.cancelled },
];

export default function StockAdjustmentsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rows = useSelector(selectStockAdjustments);
  const loadStatus = useSelector(selectStockAdjustmentsStatus);
  const error = useSelector(selectStockAdjustmentsError);

  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const searchTrimmed = useMemo(() => search.trim(), [search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchStockAdjustments({ search: searchTrimmed, status }));
    }, 250);
    return () => clearTimeout(timer);
  }, [dispatch, searchTrimmed, status]);

  return (
    <div className="stock-adjustments-page">
      <div className="header">
        <div>
          <div className="title">Корректировка остатков</div>
          <div className="sub-title">
            Исправление остатков по товарам и магазинам. Проведённый документ меняет остатки и не отменяется:
            ошибку исправляют новой корректировкой.
          </div>
        </div>
        <button type="button" className="btn-primary" onClick={() => navigate("/warehouse/adjustments/new")}>
          Создать корректировку
        </button>
      </div>

      <div className="filters">
        <input
          className="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Поиск: №, комментарий, товар, штрих-код"
        />
        <div className="status-filter">
          <Select options={STATUS_OPTIONS} value={status} onChange={(v) => setStatus(v || "")} isSearchable={false} />
        </div>
      </div>

      {loadStatus === "failed" && <div className="error">{error}</div>}

      <div className="body">
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th className="th">№</th>
                <th className="th">Статус</th>
                <th className="th">Причина</th>
                <th className="th">Магазины</th>
                <th className="th">Позиций</th>
                <th className="th">Автор</th>
                <th className="th">Создано</th>
                <th className="th">Проведено</th>
              </tr>
            </thead>
            <tbody>
              {loadStatus === "loading" && rows.length === 0 ? (
                <tr>
                  <td className="td-muted" colSpan={8}>
                    <Loading inline />
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td className="td-muted" colSpan={8}>
                    Корректировок нет.
                  </td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.id} className="tr" onClick={() => navigate(`/warehouse/adjustments/${r.id}`)}>
                    <td className="td-mono">{r.id}</td>
                    <td className="td">
                      <span className="badge" style={{ borderColor: statusColor(r.status), color: statusColor(r.status) }}>
                        {STATUS_LABELS[r.status] || r.status}
                      </span>
                    </td>
                    <td className="td">{REASON_LABELS[r.reason] || r.reason}</td>
                    <td className="td">{(r.stores || []).join(", ") || "—"}</td>
                    <td className="td">{r.items_count}</td>
                    <td className="td">{r.created_by?.username || r.created_by?.first_name || "—"}</td>
                    <td className="td">{formatDateTime(r.created_at)}</td>
                    <td className="td">{formatDateTime(r.posted_at)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
